(() => {
  if (customElements.get('faq-accordion')) {
    return;
  }

  class FAQAccordion extends HTMLElement {
    constructor() {
      super();
      this.questionButton = this.querySelector('[data-expand]');
      this.answer = this.querySelector('[data-content]');
      this.isExpanded = false;
      this.animationDuration = 300; // Duration in milliseconds

      this.questionButton.addEventListener('click', () => this.toggleAccordion());
    }

    animateHeight(startHeight, endHeight, startTime) {
      const currentTime = performance.now();
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.animationDuration, 1);

      // Easing function for smooth animation
      const easeInOutCubic = t => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      const currentHeight = startHeight + (endHeight - startHeight) * easeInOutCubic(progress);

      this.answer.style.height = `${currentHeight}px`;

      if (progress < 1) {
        requestAnimationFrame(() => this.animateHeight(startHeight, endHeight, startTime));
      } else {
        if (!this.isExpanded) {
          this.answer.style.height = '0';
        }
      }
    }

    toggleAccordion() {      
      // Close other accordions
      const allAccordions = document.querySelectorAll('faq-accordion');
      allAccordions.forEach(accordion => {
        if (accordion !== this && accordion.isExpanded) {
          accordion.toggleAccordion();
        }
      });

      this.isExpanded = !this.isExpanded;
      this.questionButton.setAttribute('aria-expanded', this.isExpanded);

      // Get the actual height of the content
      const startHeight = this.isExpanded ? 0 : this.answer.scrollHeight;
      const endHeight = this.isExpanded ? this.answer.scrollHeight : 0;

      // Start the animation
      this.animateHeight(startHeight, endHeight, performance.now());
    }
  }

  customElements.define('faq-accordion', FAQAccordion);
})();